/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface StopEventOffsetUSMarker {
  size?: number,
  borderColor?: string,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic with Offset for stop events of the asset
 *
 * ```typescript
 *  import {getStopEventOffsetUSMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getStopEventOffsetUSMarker({size, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : 0
 * }
 * ```
 */
export const getStopEventOffsetUSMarker = ({
  fillColor = dlsColor('caOrange'),
  borderColor = dlsColor('white'),
  size = 48
}: StopEventOffsetUSMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='24' y='12' width='24' height='24' rx='12' fill='${borderColor}'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M36 34C41.5228 34 46 29.5228 46 24C46 18.4772 41.5228 14 36 14C30.4772 14 26 18.4772 26 24C26.0062 29.5203 30.4797 33.9938 36 34Z' fill='${fillColor}'/>
      <path d='M39.4629 19.2298C39.8239 18.8693 40.4086 18.8692 40.7695 19.2298C41.1304 19.5909 41.1305 20.1764 40.7695 20.5374L37.3066 23.9994L40.7695 27.4622C41.1305 27.8232 41.1312 28.4088 40.7705 28.7699C40.4095 29.1309 39.824 29.1307 39.4629 28.7699L35.999 25.307L32.5371 28.7699C32.1761 29.1309 31.5906 29.1308 31.2295 28.7699C30.8687 28.4088 30.8685 27.8232 31.2295 27.4622L34.6914 23.9994L31.2295 20.5374C30.8687 20.1765 30.8689 19.5909 31.2295 19.2298C31.5905 18.8691 32.1761 18.869 32.5371 19.2298L35.999 22.6917L39.4629 19.2298ZM31.6338 28.6898C31.6366 28.691 31.6397 28.6915 31.6426 28.6927C31.6069 28.6778 31.5721 28.6599 31.5391 28.638L31.6338 28.6898ZM40.3574 28.6917C40.3928 28.677 40.4273 28.6596 40.46 28.638L40.4609 28.6361C40.4278 28.6579 40.3933 28.6767 40.3574 28.6917ZM39.7598 28.6292C39.7615 28.6305 39.7638 28.631 39.7656 28.6322C39.7338 28.6105 39.703 28.5862 39.6748 28.558L39.7598 28.6292ZM40.5576 28.558C40.5383 28.5773 40.5162 28.5926 40.4951 28.6087L40.5586 28.558C40.589 28.5275 40.6159 28.4949 40.6387 28.4603C40.6158 28.495 40.5882 28.5274 40.5576 28.558ZM40.5576 20.3246L37.0947 23.7874L40.5576 20.3255C40.5882 20.2949 40.6148 20.2617 40.6377 20.2269L40.5576 20.3246Z' fill='${borderColor}'/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getStopEventOffsetUSMarker;
